import NextLink from "next/link";
import type { ReactNode } from "react";

interface LinkProperties {
  href: string;
  children: ReactNode;
  className?: string;
  target?: string;
  rel?: string;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
  [key: string]: unknown;
}

export const Link = ({
  href,
  children,
  ...properties
}: LinkProperties): React.JSX.Element => {
  return (
    <NextLink href={href ?? ""} {...properties}>
      {children}
    </NextLink>
  );
};
